<template>
	<div class="content">
		<!-- 案例展示 -->
		<div class="banner wow animate__animated animate__fadeInUp animate__delay-0.3s">
			<img src="../../static/images/case/banner.png" alt="" v-show="currlangs == 0">
			<img src="../../static/images/case/eng/1.png" alt="" v-show="currlangs == 1">
			<img src="../../static/images/case/eng/1.png" alt="" v-show="currlangs == 2">
		</div>
		<router-view></router-view>
	</div>
</template>

<script>
	import { WOW } from 'wowjs'
	import casesNav from './casesNav.vue'
	
	export default {
	  name: 'casesNav',
	  components:{
	    casesNav
	  },
		data() {
			return {
				showLoading: true,
				
				currlangs: 0, //0中文 1英文 2西班牙语
				langs: zh, 
			}
		},
		mounted() {
			let _this = this;
			_this.currlangs = sessionStorage.getItem('UPUS_langs');
			if(_this.currlangs == 2) {
				_this.langs = sp;
			} else if(_this.currlangs == 1) {
				_this.langs = eng;
			} else {
				_this.langs = zh;
			}
		},
		methods: {
			
		}
	}
</script>

<style scoped>
	
</style>



// WEBPACK FOOTER //
// src/views/cases.vue